import cusTable from "./cusTable"

const index = {
    install(Vue){
        Vue.component('cusTable',cusTable)
    }
};

export default index;
